import React from "react";
import "../styles/FormCreditoEspecial.css";

const CuotaPreCalculada = ({ tasa, montop, Precalcular, saldo_limite_cuota, diasDiferimiento, calificacion }) => {
  const valorCta = () => {
    //console.log(monto, tasa.cuotas)
    if (montop === null || tasa.cuotas === null || montop === undefined || saldo_limite_cuota < 0) {
      return 0;
    } else {
      const capital = montop;
      const interes = parseFloat((tasa.tna / 12) / 100);
      const meses = tasa.cuotas;

      const factor = Math.pow(interes + 1, meses);

      //calculo interes dia diferimiento
      //Importe de DF= Interes TNA / 365 *Total del crédito * Días de Diferimiento / Cantidad de cuotas
      const interesDF = diasDiferimiento > 0 ? parseFloat((montop * (tasa.tna / 100) * (diasDiferimiento / 365)) / meses) : 0;

      const cuota = ((capital * interes * factor) / (factor - 1) + interesDF).toFixed(2);
      //console.log(interesDF, cuota);

      return cuota;
    }
  };

  // Calcular TEA correctamente desde TNA
  // TEA = (1 + TNA_mensual)^12 - 1
  const calcularTEA = () => {
    const tnaMensual = tasa.tna / 12 / 100; // TNA anual → mensual → decimal
    const tea = (Math.pow(1 + tnaMensual, 12) - 1) * 100; // Convertir a porcentaje
    return tea.toFixed(2);
  };

//console.log(saldo_limite_cuota);

  const label = (premium, tasa_premium) => {
    switch (premium) {
      case "SI":{
        if(tasa_premium == "1"){
          return <button
          style={{ display: saldo_limite_cuota > 0 ? "block" : "none" }}
          type="button"
          className="precalculo-option premium-option"
          onClick={() => {
            Precalcular(tasa, montop);
          }}>
          <div className="precalculo-badge premium-badge">
            <i className="bi bi-star-fill me-1"></i>
            Premium
          </div>
          <div className="precalculo-details">
            <div className="precalculo-row">
              <span className="precalculo-label">Cuotas:</span>
              <span className="precalculo-value">{tasa.cuotas}</span>
            </div>
            <div className="precalculo-row">
              <span className="precalculo-label">Cuota mensual:</span>
              <span className="precalculo-value-highlight">${new Intl.NumberFormat('es-AR').format(valorCta())}</span>
            </div>
            <div className="precalculo-row">
              <span className="precalculo-label">TEA:</span>
              <span className="precalculo-value">{calcularTEA().toString().replace(/\./g, ',')}%</span>
            </div>
            <div className="precalculo-row">
              <span className="precalculo-label">TNA:</span>
              <span className="precalculo-value">{(tasa.tna).toString().replace(/\./g, ',')}% anual</span>
            </div>
            <div className="precalculo-row">
              <span className="precalculo-label">Tipo:</span>
              <span className="precalculo-value">{tasa.descripcion}</span>
            </div>
          </div>
        </button>
        }
      }break;
      case "NO":{
        if(tasa_premium !== "1"){
          return  <button
          style={{ display: valorCta() <= saldo_limite_cuota ? "block" : "none" }}
          type="button"
          className="precalculo-option standard-option"
          onClick={() => {
            Precalcular(tasa, montop);
          }}
        >
          <div className="precalculo-details">
            <div className="precalculo-row">
              <span className="precalculo-label">Cuotas:</span>
              <span className="precalculo-value">{tasa.cuotas}</span>
            </div>
            <div className="precalculo-row">
              <span className="precalculo-label">Cuota mensual:</span>
              <span className="precalculo-value-highlight">${new Intl.NumberFormat('es-AR').format(valorCta())}</span>
            </div>
            <div className="precalculo-row">
              <span className="precalculo-label">TEA:</span>
              <span className="precalculo-value">{calcularTEA().toString().replace(/\./g, ',')}%</span>
            </div>
            <div className="precalculo-row">
              <span className="precalculo-label">TNA:</span>
              <span className="precalculo-value">{(tasa.tna).toString().replace(/\./g, ',')}% anual</span>
            </div>
          </div>
        </button>
        }
      } break;
    }
  }

  return <>
    {
    calificacion && tasa
    ? label(calificacion.premium, tasa.premium)
    : ""
    }
  </>
};

export default CuotaPreCalculada;
